import { createActionHelpers } from 'vuex-loading';
import localForage from 'localforage';
import Auth from '@js/plugins/auth';

const store = localForage.createInstance({
    storeName: `restriction_${Auth.user().id}`,
    namespaced: true,
});

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const restriction = {
    id: null,
    name: null,
    outlets: [],
    includedLabels: [],
    excludedLabels: [],
    description: null,
    active_date: new Date().toISOString().split('T')[0], // Set today's date as default
    deactivate_date: new Date().toISOString().split('T')[0], // Set today's date as default
    start_time: '12:00:00',
    end_time: '12:00:00',
    type: '',
    minimum_age: null,
    subcategories: [],
    days: [],
    from_time: null,
    until_time: null,
    selectedSubCategory: [],
};

const state = {
    searchMeta: null,
    filters: [],
    restriction,
    stationsPoolCount: null,
    stationsPool: {},
    includedLabels: [],
    excludedLabels: [],
};

const getters = {
    restriction: state => state.restriction,
    stationsPoolCount: state => state.stationsPoolCount,
    stationsPool: state => state.stationsPool,
    includedLabels: state => state.includedLabels,
    excludedLabels: state => state.excludedLabels,
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setSelectedSubCategory(state, subcategories) {
        state.restriction.selectedSubCategory = subcategories;
    },

    setSubcategory(state, subcategories) {
        state.restriction.subcategories = subcategories;
    },

    async setFilters(state, filters) {
        state.filters = filters;
        await store.setItem('filters', filters);
    },

    setRestrictionAttr(state, { key, value }) {
        if (Array.isArray(value)) {
            state.restriction[key] = [...value];
        } else {
            state.restriction[key] = value;
        }
    },

    setStationsPool(state, data) {
        state.stationsPool = data;
    },

    setStationsPoolCount(state, data) {
        state.stationsPoolCount = data;
    },

    setIncludedLabels(state, includedLabels) {
        state.includedLabels = includedLabels;
    },

    setExcludedLabels(state, excludedLabels) {
        state.excludedLabels = excludedLabels;
    },

    setSelectedStations(state, stations) {
        state.restriction.outlets = stations;
    },
};

const actions = {
    setRestrictionAttr({ commit }, { key, value }) {
        commit('setRestrictionAttr', { key, value });
    },

    async getStationsCount({ dispatch, commit }, { filters }) {
        startLoading(dispatch, 'fetch-stations-count');
        const url = Laroute.route('franchise.restriction.stations_count');
        const { data } = await axios.get(url, { params: filters });
        endLoading(dispatch, 'fetch-stations-count');

        commit('setStationsPoolCount', data.count);

        return data.count;
    },

    async getStations({ dispatch, commit }, { params }) {
        startLoading(dispatch, 'fetch-stations');

        const url = Laroute.route('franchise.restriction.stations');
        const { data } = await axios.get(url, { params });
        endLoading(dispatch, 'fetch-stations');

        commit('setStationsPool', data.data);

        return data.data;
    },

    async getSubCategoryList({ commit, dispatch }, params) {
        const url = Laroute.route('franchise.restriction.sub-category');
        startLoading(dispatch, 'fetch-subcategory-list');

        try {
            let options = {
                params: {
                    ...params,
                },
            };

            const { data } = await axios.get(url, options);
            commit('setSubcategory', data.data || []);
            endLoading(dispatch, 'fetch-subcategory-list');
            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-subcategory-list');
            throw e;
        }
    },

    async createRestriction({ commit, dispatch }, restriction) {
        let route = Laroute.route('franchise.restriction.store');
        startLoading(dispatch, 'save-restriction');
        return axios
            .post(route, restriction)
            .then(res => {
                endLoading(dispatch, 'save-restriction');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-restriction');
                throw err;
            });
    },

    async updateRestriction({ commit, dispatch }, restriction) {
        let route = Laroute.route('franchise.restriction.update', {
            id: restriction.id,
        });
        startLoading(dispatch, 'update-restriction');
        return axios
            .put(route, restriction)
            .then(res => {
                endLoading(dispatch, 'update-restriction');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'update-restriction');
                throw err;
            });
    },

    async getRestrictionById({ dispatch }, id) {
        startLoading(dispatch, 'fetch-restriction');
        try {
            const route = Laroute.route('franchise.restriction.edit', {
                id,
            });
            const { data } = await axios.get(route);
            endLoading(dispatch, 'fetch-restriction');
            return data;
        } catch (error) {
            endLoading(dispatch, 'fetch-restriction');
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/restriction.js